<template>
    <router-link
        to="/reports"
        :class="{'pointer-events-none opacity-50': editMode}"
        class="redesign-manage-reports"
    >
        <div class="flex items-center">
            <span class="px-1">
                <RedesignBaseIcon
                    name="ClipboardList"
                    :size="22"
                />
            </span>
            <span class="px-1 hidden xl:inline-flex">
                {{ $t('report.manageReports') }}
            </span>
        </div>
    </router-link>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router/composables'
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'

defineProps<{
    editMode?: boolean
}>()

const route = useRoute()

const showButton = ref<boolean>(true)

function  updateButtonVisibility (routeName: string) {
    showButton.value = !routeName.includes('reports')
}

watch(
    () => route.name,
    (val) => {
        if (!val) {
            return
        }
        updateButtonVisibility(val)
    }
)
</script>

<style lang="scss">
    .redesign-manage-reports {
        @apply
        h-9
        transition
        flex items-center justify-center
        border border-ui-lines
        rounded
        text-sm font-medium text-primary-actions
        px-2
        focus:ring-1 focus:ring-active-elements focus:border-active-elements
        outline-none;
        background-color: color-mix(in srgb, var(--primary-actions) 5%, transparent);
        &:hover {
            background-color: color-mix(in srgb, var(--primary-actions) 15%, transparent);
        }
    }
</style>
